'use client'

import { FC } from 'react'

import { Body, Header } from './components'
import { Subcomponents, TableBaseProps } from './types'

const TableBase: FC<TableBaseProps> & Subcomponents = ({
  children,
  className = '',
}) => {
  return <div className={`grid ${className}`}>{children}</div>
}

TableBase.Header = Header
TableBase.Body = Body

export default TableBase
